export const UNIT_MAP = {
  "Calc Pump Rate": " rpm",
  "Calc Stroke Rate": " Stroke/min",
  "Calc Trans RPM": " rpm",
  "Pump Rate": " bbl/min",
  "Suction Pressure": " psi",
  "DUAL FUEL RATIO": " %",
  "Engine Coolant Temp": " degF",
  "Engine Hours": "  h",
  "Engine Load": " %",
  "Engine Oil Pressure": " psi",
  "Engine RPM": "  rpm",
  "FUEL RATE": " gal/hr",
  "Calc Horse Power": " hp",
  "PE Oil Pressure": " psi",
  "PE Oil Temp": " degF",
  "Trans Gear": " ",
  "Trans Oil Pressure": " psi",
  "Trans Temp": " degF",
  Voltage: " V",
  "Calc PE RPM": " rpm",
  "FE Vibration": " %",
};
